import { render, staticRenderFns } from "./WeekDataFormatter.vue?vue&type=template&id=2ddb6316&functional=true"
import script from "./WeekDataFormatter.vue?vue&type=script&lang=js"
export * from "./WeekDataFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports